import { defineCustomElement } from "vue";
import CreateUserForm from "@/components/CreateUserForm.ce.vue";

const componentName = "qntn-form";

if (!customElements.get(componentName)) {
  customElements.define(componentName, defineCustomElement(CreateUserForm));
}
